module.exports = __webpack_public_path__ + "assets/2d57969af9890f637bfcd9ffa97c66ad.mp3";